import { render } from "./DefContent.vue?vue&type=template&id=d930aa04&scoped=true"
import script from "./DefContent.vue?vue&type=script&lang=js"
export * from "./DefContent.vue?vue&type=script&lang=js"

import "./DefContent.vue?vue&type=style&index=0&id=d930aa04&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d930aa04"]])

export default __exports__